import {isNil, isNotNil} from 'ramda';

import i18n from '@dms/i18n';

import {Nullish, parseDate} from 'shared/web';

type ShortDateFormatter = (format: 'dateShort', date: Date) => string;

export function formatFinancingTemplateValidity(
  validFrom: string | Nullish,
  validTo: string | Nullish,
  formatDate: ShortDateFormatter
) {
  const from = parseDate(validFrom);
  const to = parseDate(validTo);

  if (isNil(from) && isNil(to)) {
    return i18n.t('general.labels.unlimited');
  }

  const formattedFrom = isNotNil(from) ? formatDate('dateShort', from) : '';
  const formattedTo = isNotNil(to) ? formatDate('dateShort', to) : '';

  return `${formattedFrom} – ${formattedTo}`.trim();
}
